import axiosBase from "@/api/axiosBase";

const state = {}

const getters = {}

const actions = {
    //瓦片生成
    setTileMake({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            let zoom = '';
            if(data.hasOwnProperty('max_zoom')){
                zoom = '&max_zoom=' + data.max_zoom;
            }
            axiosBase({
                method:'POST',
                url:'/basedata/gis/tiles_make?file_id=' + data.file_id + zoom
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //切片数据
    getTileMeta({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'GET',
                url:'/basedata/gis/tiles_meta?file_id=' + data.file_id
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //切片任务状态
    getTileStatus({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'GET',
                url:'/basedata/gis/tiles_status?file_id=' + data.file_id
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
}

const mutations = {}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}